import React from 'react'
interface StatusCompleteIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export function StatusCompleteIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}: StatusCompleteIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" />
      {/* Checkmark */}
      <path d="M9 12l2 2 4-5" />
    </svg>
  )
}
